import { apiScoping } from '@/lib/api/scoping'
import {
  CreatePlantAssessmentDocumentResponseSchema,
  type CreatePlantAssessmentDocumentResponse
} from '@/features/plant-assessment/api/plant-assessment-document'

export type CreateAraDraftDocumentInput = {
  plantId: string
  title: string
  isPublic?: boolean
  /** Aborted by the provider's sync bound (see putDocumentSource). */
  signal?: AbortSignal
}

/**
 * Creates the kind=ara draft document (status draft, no HTML) born at
 * generation completion (ADR 0001). The editable source lands separately via
 * putDocumentSource; the published snapshot only arrives at publish.
 */
export async function createAraDraftDocument(
  input: CreateAraDraftDocumentInput
): Promise<CreatePlantAssessmentDocumentResponse> {
  const res = await apiScoping.post(
    `/api/v1/plant-assessment/${input.plantId}/docs`,
    {
      title: input.title,
      kind: 'ara',
      status: 'draft',
      ...(input.isPublic !== undefined ? { isPublic: input.isPublic } : {})
    },
    { signal: input.signal }
  )
  const result = CreatePlantAssessmentDocumentResponseSchema.safeParse(res.data)
  if (!result.success) {
    console.error(
      '[documents-draft-create] Zod parse failed - raw response:',
      res.data,
      'issues:',
      result.error.issues
    )
    throw result.error
  }
  return result.data
}
